<template>
    <div>
        <loading-block v-if="dataIsLoading">
        </loading-block>
        <div v-else>
            <h1 class="main-title">Mon compte</h1>
            <div class="section-container">
                <section>
                    <h2 class="subtitle">Mes informations</h2>
                    <ValidationObserver ref="observer"
                                        v-slot="{ invalid }"
                                        tag="form"
                                        @submit.prevent="updateUserInfos()"
                                        class="form-container"
                    >
                        <uni-input-container label="Prénom" for="firstname">
                            <uni-input rules="alpha_dash|required"
                                       v-model="user.firstname"
                                       id="firstname"
                                       :val="user.firstname"
                            />
                        </uni-input-container>

                        <uni-input-container label="Nom">
                            <uni-input rules="alpha_dash|required"
                                       v-model="user.name"
                                       id="name"
                                       :val="user.name"
                            />
                        </uni-input-container>

                        <uni-input-container label="Adresse" for="street">
                            <uni-input rules="required"
                                       v-model="user.street"
                                       id="street"
                                       :val="user.street"
                            />
                        </uni-input-container>

                        <uni-input-container label="Code postal"
                                             for="postalCode">
                            <uni-input rules="required|digits:5"
                                       v-model="user.postal_code"
                                       id="postalCode"
                                       mode="eager"
                                       :val="user.postal_code"
                            />
                        </uni-input-container>

                        <uni-input-container label="Ville" for="city">
                            <uni-input rules="required"
                                       v-model="user.city"
                                       id="city"
                                       :val="user.city"
                            />
                        </uni-input-container>

                        <uni-input-container label="Téléphone"
                                             for="tel"
                        >
                            <uni-input rules="required|digits:10"
                                       v-model="user.tel"
                                       id="tel"
                                       :val="user.tel"
                            />
                        </uni-input-container>
                        <uni-loading-button :is-disable="loading" text="Enregistrer les modifications"></uni-loading-button>
                        <info-message v-if="familyUpdateSuccess" :status="familyUpdateStatus">
                            Modifications enregistrées
                        </info-message>
                    </ValidationObserver>
                </section>
                <section>
                    <h2 class="subtitle">Paramètres</h2>
                    <!--                    Adresse e-mail <br>-->
                    <!--                    {{ user.email }}-->
                    <uni-cta-link to="/deconnexion"
                                  class="uni-cta-link--secondary"
                    >
                        Se déconnecter
                    </uni-cta-link>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import LoadingBlock from "../../components/c-blocks/LoadingBlock";
    import UniInputContainer from "../../components/a-elements/UniInputContainer";
    import UniInput from "../../components/a-elements/UniInput";
    import InfoMessage from "../../components/a-elements/InfoMessage";
    import UniButton from "../../components/a-elements/UniButton";
    import {mapGetters} from "vuex";
    import UniCtaLink from "../../components/a-elements/UniCtaLink";
    import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";

    export default {
        name: "AdminAccount",
        components: {UniLoadingButton, UniCtaLink, UniButton, InfoMessage, UniInput, UniInputContainer, LoadingBlock},
        data(){
            return{
                dataIsLoading: true,
                loading: false,
                familyUpdateSuccess: false,
                familyUpdateStatus: 'success',
                user: {},
                family: {}
            }
        },
        computed:{
            ...mapGetters({
                currentFamily: 'currentFamily'
            })
        },
        methods:{
            updateUserInfos(){
                this.loading = true
                this.$updateModel('users', {user: this.user} , this.user.id)
                    .then(data => {
                        console.log('infos successfully updated')
                        this.familyUpdateSuccess = true
                        window.setTimeout(() =>{
                            this.familyUpdateSuccess = false
                        }, 3000)
                        this.loading = false
                    })
                    .catch(data =>{
                        console.log('what ça a pas fonctionné')
                        this.familyUpdateSuccess = true
                        window.setTimeout(() =>{
                            this.familyUpdateSuccess = false
                        }, 3000)
                        this.familyUpdateStatus = 'warning'
                    })
            },
        },
        created(){
            this.$getModel('families', this.currentFamily.id)
                .then(data => {
                    this.family = data
                    this.user = this.family.users[0]
                    this.$nextTick(() => {
                        this.dataIsLoading = false
                    })
                })
        },
    }
</script>

<style scoped lang="scss">
    .section-container{
        display:grid;
        gap: 24px;
    }

    @include screen-m{
        .section-container{
            display:grid;
            grid-template-columns: 1fr 1fr;
            gap: 24px;
        }
    }
</style>
